import React, { useState, useEffect, useCallback } from 'react';
import { Gift, Loader2, Save } from 'lucide-react';
import { apiService } from '../../services/api.service';
import { API_ENDPOINTS } from '../../config/environment';
import { fleetToast } from '../../utils/toast';
import './PackageBonusPage.css';

const PackageBonusPage = () => {
  const [enabled, setEnabled] = useState(false);
  const [threshold, setThreshold] = useState('');
  const [perPackage, setPerPackage] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiService.get(API_ENDPOINTS.FLEET_PANEL.BONUS_SETTINGS);
      if (res.success && res.data) {
        setEnabled(!!res.data.enabled);
        setThreshold(res.data.dailyThreshold ?? '');
        setPerPackage(res.data.perPackageAmount ?? '');
      }
    } catch { /* sessiz */ } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    if (enabled && (!threshold || Number(threshold) < 1)) { fleetToast.error('Günlük limit 1 veya üzeri olmalı'); return; }
    if (enabled && (perPackage === '' || Number(perPackage) < 0)) { fleetToast.error('Paket başı bonus 0 veya üzeri olmalı'); return; }
    setSaving(true);
    try {
      const res = await apiService.put(API_ENDPOINTS.FLEET_PANEL.BONUS_SETTINGS, {
        enabled,
        dailyThreshold: enabled ? Number(threshold) : null,
        perPackageAmount: enabled ? Number(perPackage) : null,
      });
      if (res.success) fleetToast.success('Paket bonusu ayarı kaydedildi');
      else fleetToast.error(res.error || 'Kaydetme başarısız');
    } catch { fleetToast.error('Kaydetme sırasında hata oluştu'); } finally { setSaving(false); }
  };

  const example = enabled && threshold && perPackage
    ? `Örnek: limit ${threshold}, ${perPackage}₺/paket ise kurye ${Number(threshold) + 15} paket = ${15 * Number(perPackage)}₺ bonus`
    : null;

  if (loading) return <div className="pb-loading"><Loader2 className="spinning" size={40} /></div>;

  return (
    <div className="pb-container">
      <div className="page-header">
        <div className="header-left">
          <div className="page-icon"><Gift size={20} /></div>
          <div className="page-title"><h1>Paket Bonusu</h1><p>Günlük paket limitini aşan kuryelere paket başı bonus</p></div>
        </div>
      </div>
      <div className="pb-card">
        <label className="pb-toggle-row">
          <span className="pb-switch">
            <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />
            <span className="pb-switch-track" />
          </span>
          <span className="pb-toggle-label">Paket bonusunu etkinleştir</span>
        </label>
        <div className={`pb-fields ${enabled ? '' : 'pb-disabled'}`}>
          <div className="pb-field">
            <label>Günlük paket limiti</label>
            <input type="number" min="1" value={threshold} disabled={!enabled} onChange={(e) => setThreshold(e.target.value)} placeholder="Örn: 40" />
          </div>
          <div className="pb-field">
            <label>Limit üstü paket başı bonus (₺)</label>
            <input type="number" min="0" step="0.01" value={perPackage} disabled={!enabled} onChange={(e) => setPerPackage(e.target.value)} placeholder="Örn: 5" />
          </div>
        </div>
        {example && <div className="pb-example">{example}</div>}
        <button className="pb-save" onClick={save} disabled={saving}>
          {saving ? <Loader2 size={16} className="spinning" /> : <Save size={16} />} Kaydet
        </button>
      </div>
    </div>
  );
};

export default PackageBonusPage;
